export const HERO_CHECK_COMPENSATION_EVENT_UA = ["clicked", "Hero", "CheckYourCompensation"] as const;
export const HERO_CHECK_COMPENSATION_EVENT = { event: "check_compensation", label: "check_your_compensation", placement: "hero" } as const;
